module.exports = __webpack_public_path__ + "img/5.5d8a6337.png";